function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M34.254 13.113l5.818 6.097c5.37 5.629.628 16.791-5.636 23.355-6.415 6.721-16.996 11.459-22.29 5.91L6.326 42.38",
  stroke: "#4D4D4D",
  strokeWidth: 2.5,
  strokeMiterlimit: 10
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M31.4 16.105l-3.33 3.488M12.52 35.889l-3.372 3.533M12.747 28.019c-1.068 1.005-1.765 2.352-1.765 3.974 0 3.03 2.345 5.508 5.236 5.508 2.892 0 5.236-2.478 5.236-5.508 0-.673-.115-1.318-.327-1.915l-1.672-4.706a5.685 5.685 0 01-.328-1.915c0-3.03 2.345-5.466 5.236-5.466 2.892 0 5.237 2.436 5.237 5.466a5.59 5.59 0 01-1.74 4.085M46.403 30.687c11.558 6.84 18.525 22.226 12.287 28.763-5.504 5.768-17.831.808-25.213-9.34M62.665 38.053c2.351 3.769 3.858 7.571 4.462 11.126m.235 4.965a15.414 15.414 0 01-.37 2.28M9.705 12.552c3.027-3.196 6.261-5.532 9.453-6.892m4.585-1.276a13.454 13.454 0 012.205-.097",
  stroke: "#4D4D4D",
  strokeWidth: 2.5,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M58.69 59.45l-5.819 6.097c-6.035 6.325-19.98-.288-26.818-11.77M55.852 56.476l-3.359-3.522M38.07 45.318c.757.452 1.632.719 2.564.719a5.03 5.03 0 001.827-.365l4.491-1.752a5 5 0 011.827-.322c2.892 0 5.256 2.437 5.256 5.467s-2.364 5.508-5.256 5.508c-1.549 0-2.94-.726-3.898-1.844M21.87 64.938v2.612M21.87 54.485v5.226M54.172 29.665v-4.968M6.327 42.379C4.754 40.727 4.008 38.45 4 35.852c-.016-5.15 2.864-11.563 7.937-16.887 4.154-4.36 10.326-8.356 16.166-8.29 2.321.027 4.528.736 6.15 2.44 1.568 1.644 2.314 3.905 2.328 6.485.028 5.145-2.852 11.561-7.937 16.897-5.064 5.314-11.1 8.28-15.955 8.32-2.55.021-4.773-.773-6.362-2.438v0zM54.172 19.73v-1.242M54.172 13.52v-1.242",
  stroke: "#4D4D4D",
  strokeWidth: 2.5,
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

function SvgPricing(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2, _ref3);
}

export default __webpack_public_path__ + "/img/pricing.svg";
export { SvgPricing as ReactComponent };